import React, { useCallback, useEffect, useState } from 'react';
import { Col, Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useAbility } from '@casl/react';
import HRDashboardStyled from '../../HRDashboardStyled';
import { debounceIndexProfileSelectionProcessesRequest } from '../../../requests/selectionProcesses';
import { AbilityContext } from '../../../config/abilityContext';

const DEFAULT_CUSTOM_PARAMS = {
  status: 'active',
  filter_process_type: 'internal,mixed'
};

const InternalVacanciesCard = () => {
  const ability = useAbility(AbilityContext);
  const [showSpinner, setShowSpinner] = useState(0);
  const dispatch = useDispatch();
  const history = useHistory();
  const [amount, setAmount] = useState(0);
  const canIndex = ability.can('index', 'SelectionProcess');

  const handleCardClick = () => {
    history.push('/profile/job_offers');
  };

  const handleSuccessIndex = useCallback(response => {
    const { amount: responseAmount } = response.data.metadata;
    setAmount(responseAmount);
    setShowSpinner(0);
  }, []);

  const handleIndexRequest = useCallback(
    params => {
      if (!canIndex) return;
      setShowSpinner(1);
      const sendParams = { ...params, ...DEFAULT_CUSTOM_PARAMS };
      debounceIndexProfileSelectionProcessesRequest({
        dispatch,
        params: sendParams,
        successCallback: handleSuccessIndex,
        failureCallback: () => setShowSpinner(0)
      });
    },
    [dispatch, handleSuccessIndex, canIndex]
  );
  useEffect(() => {
    handleIndexRequest({});
  }, [handleIndexRequest]);

  return (
    <>
      {showSpinner ? (
        <Col className="mt-5">
          <div className="containerSpinnerLoadDash mb-5">
            <Spinner animation="border" variant="primary" />
          </div>
        </Col>
      ) : (
        <>
          <HRDashboardStyled
            title={amount}
            label="Vacantes Internas"
            labelColor="#827f7f"
            TopHeaderColor="#fff"
            GeneralColor="#077306"
            subtitle="Vacantes"
            TypeCard="OnlyInformation"
            onRequest={false}
            Downloadable={false}
            labelFontSize="12px"
            ViewMore={canIndex}
            onClick={handleCardClick}
          />
        </>
      )}
    </>
  );
};

export default InternalVacanciesCard;
